import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Gamepad2, Sparkles, Loader2, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CinematicPlayer } from "@/components/CinematicPlayer";

export default function CinematicView() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    let alive = true;
    api.get(`/cinematic/view/${slug}`)
      .then((r) => { if (alive) setState({ loading: false, data: r.data, error: null }); })
      .catch(() => { if (alive) setState({ loading: false, data: null, error: "not found" }); });
    return () => { alive = false; };
  }, [slug]);

  if (state.loading) return <div className="min-h-screen grid place-items-center bg-[#07070b]"><Loader2 className="w-8 h-8 animate-spin text-white/70" /></div>;

  if (state.error || !state.data) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#07070b] text-center px-6">
        <div>
          <AlertTriangle className="w-10 h-10 mx-auto text-amber-400 mb-3" />
          <p className="text-white/80">This trailer isn't available.</p>
          <Link to="/"><Button className="mt-4 rounded-full">Go to GameView Studio</Button></Link>
        </div>
      </div>
    );
  }

  const c = state.data;
  const rendering = c.status === "processing";

  return (
    <div className="min-h-screen bg-[#07070b] text-white flex flex-col" data-testid="cinematic-view">
      <div className="flex-1 grid place-items-center px-4 py-8">
        <div className="w-full max-w-3xl">
          <div className="flex items-center justify-center gap-2 mb-4 text-white/50 text-xs font-semibold uppercase tracking-widest">
            <Sparkles className="w-3.5 h-3.5" /> AI-generated cinematic
          </div>
          {rendering ? (
            <div className="aspect-video grid place-items-center rounded-2xl bg-black/60 text-white/70"><Loader2 className="w-7 h-7 animate-spin mr-2" /> Rendering…</div>
          ) : (
            <CinematicPlayer cinematic={c} autoplay />
          )}
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-center sm:text-left">
              <p className="font-display text-lg font-bold">{c.game_title || c.title}</p>
              <p className="text-xs text-white/50">Made with GameView Studio</p>
            </div>
            <div className="flex items-center gap-2">
              {c.game_id && (
                <Link to={`/g/${c.game_id}`}><Button className="rounded-full bg-emerald-600 hover:bg-emerald-500 text-white border-0" data-testid="cinematic-play-game"><Gamepad2 className="w-4 h-4" /> Play this game</Button></Link>
              )}
              <Link to="/"><Button variant="outline" className="rounded-full border-white/20 text-white hover:bg-white/10">Make your own</Button></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
